import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.667 2.787v10.426c0 1.171.949 2.12 2.12 2.12h10.426c1.171 0 2.12-.949 2.12-2.12V2.787c0-1.171-.949-2.12-2.12-2.12H2.787c-1.171 0-2.12.949-2.12 2.12m1.333 0C2 2.352 2.352 2 2.787 2H4v2H2zm0 2.546h2v2H2zM14 4V2.787A.787.787 0 0 0 13.213 2H12v2zm-2 1.333h2v2h-2zM10.667 2H5.333v5.333h5.334zM14 8.667v2h-2v-2zM14 12h-2v2h1.213a.787.787 0 0 0 .787-.787zm-3.333-3.333V14H5.333V8.667zM2 12v1.213c0 .435.352.787.787.787H4v-2zm2-1.333H2v-2h2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })